export interface ThemeTokens {
  /* Page background */
  bg: string;
  bgGradient: string;

  /* Glass surfaces */
  surface: string;
  surfaceStrong: string;
  surfaceBorder: string;
  blockShadow: string;
  blockShadowHover: string;
  radius: string;
  radiusLg: string;

  /* Text */
  text: string;
  textMuted: string;

  /* Accents */
  accentPrimary: string;
  accentSecondary: string;
  accentGlow: string;
  /** RGB triple used to build translucent accent rgba() values, e.g. "99, 102, 241". */
  accentRgb: string;
  /** Foreground color placed on top of accent fills. */
  accentInk: string;

  /* Controls */
  primary: string;
  primaryHover: string;
  danger: string;
  dangerRgb: string;
  success: string;
  warning: string;

  /* Typography */
  fontFamily: string;

  /* Accent-fill buttons */
  btnGradient: string;
  btnGradientHover: string;

  /* Glassmorphism */
  blur: string;
}

export interface Theme {
  id: string;
  name: string;
  tokens: ThemeTokens;
}

/* glass: light frosted neumorphism + glassmorphism for the admin dashboard. */
export const glassTheme: Theme = {
  id: 'glass',
  name: 'Glass',
  tokens: {
    bg: '#eef1f7',
    bgGradient:
      'radial-gradient(1200px 800px at 8% -4%, #eef1ff 0%, transparent 55%), radial-gradient(1100px 750px at 104% 0%, #fdeef6 0%, transparent 55%), radial-gradient(900px 700px at 50% 115%, #e8f5f3 0%, transparent 60%), linear-gradient(180deg, #f4f6fb 0%, #e9edf4 100%)',
    surface: 'rgba(255, 255, 255, 0.62)',
    surfaceStrong: 'rgba(255, 255, 255, 0.92)',
    surfaceBorder: 'rgba(255, 255, 255, 0.6)',
    blockShadow: '7px 7px 16px rgba(163, 177, 198, 0.35), -7px -7px 16px rgba(255, 255, 255, 0.85)',
    blockShadowHover:
      '10px 10px 22px rgba(163, 177, 198, 0.45), -10px -10px 22px rgba(255, 255, 255, 0.95)',
    radius: '14px',
    radiusLg: '18px',
    text: '#3b4252',
    textMuted: '#6b7280',
    accentPrimary: '#6366f1',
    accentSecondary: '#a5b4fc',
    accentGlow: '0 0 0 4px rgba(99, 102, 241, 0.16)',
    accentRgb: '99, 102, 241',
    accentInk: '#ffffff',
    primary: '#6366f1',
    primaryHover: '#4f46e5',
    danger: '#ef4444',
    dangerRgb: '239, 68, 68',
    success: '#22a06b',
    warning: '#f59e0b',
    fontFamily: "'Rubik', 'Segoe UI', Tahoma, sans-serif",
    btnGradient: 'linear-gradient(135deg, #818cf8 0%, #6366f1 60%, #4f46e5 100%)',
    btnGradientHover: 'linear-gradient(135deg, #929dff 0%, #7873f7 60%, #5b52ec 100%)',
    blur: '22px',
  },
};

export const themes: Record<string, Theme> = {
  [glassTheme.id]: glassTheme,
};

export const defaultThemeId = glassTheme.id;
